(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main')
    .controller('RolsMainCtrl', RolsMainCtrl);

  function RolsMainCtrl() {
    var vm = this;
    vm.ctrlName = 'RolsMainCtrl';
  }
}());
